"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const TickIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 20 20" }),
    react_1.default.createElement("circle", { cx: "10", cy: "10", r: "10" }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7294 7.35061L8.8133 14.7277L4.33545 10.7474L5.66418 9.25259L8.68632 11.9389L14.2703 5.98273L15.7294 7.35061Z", fill: "white" })));
exports.TickIcon = TickIcon;
exports.default = exports.TickIcon;
